// Generated by CoffeeScript 2.7.0
var TextFieldMixin;

export default TextFieldMixin = {
  methods: {
    userInput: function(event) {
      return this.valueChange(event.target.value.trim());
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      return this.value = entry.value;
    },
    _focus: function() {
      return this.$refs.input.focus();
    }
  }
};
